var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { click: _vm.onClick } },
    [
      _c("ui-badge", { attrs: { text: _vm.COUNT, "max-width": "50" } }),
      _c("f-sprite-icon", {
        attrs: { "icon-link": _vm.$options.icons.IconHeart.id }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }